<template>
    <div>
      <drawer-dialog-controls
        class="dialog-controls"
        :is-loading="isLoading"
        @close="$emit('close')"
        @save="onSubmit"
      >
        Add IP address to White List
      </drawer-dialog-controls>
      <v-card-text class="flex-grow-1 pt-6">
        <div class="d-flex justify-space-between align-start mb-1">
          <span class="body-2 font-weight-medium">IP Address</span>
          <span class="caption grey--text">IPv6 addresses are also supported</span>
        </div>
        <v-textarea
          v-model="ipInput"
          outlined
          dense
          hide-details
          rows="4"
          placeholder="192.168.1.1, 192, 234.1.2.34"
        />

        <v-text-field
          v-model="comment"
          label="Description (optional)"
          placeholder="Enter a description"
          class="mt-4"
          hide-details
        />
      </v-card-text>
    </div>
</template>

<script>
  import { DrawerDialogControls } from '@/components/core/DrawerDialog'

  export default {
    name: 'MainSettingsIpForm',
    components: {
      DrawerDialogControls,
    },
    props: {
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        ipInput: '',
        comment: '',
      }
    },
    methods: {
      onSubmit() {
        const entries = this.ipInput
          .split(',')
          .map(ip => ip.trim())
          .filter(ip => ip.length > 0)
          .map(ip => ({ ip, comment: this.comment.trim() }))

        this.$emit('save', entries)
      },
      reset() {
        this.ipInput = ''
        this.comment = ''
      },
    },
  }
</script>
